import React from "react";

import { Launch as LaunchIcon } from "@material-ui/icons";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import Dropdown from "../../dropdown/Dropdown";

import type { JSX } from "react";

interface ILink {
  link: { link: string; projectName: string }[] | string;
  label: string;
  icon: JSX.Element;
  disabled?: boolean;
  isExternal?: boolean;
}

function MediaLink(props: ILink): JSX.Element {
  const { link, disabled, label, icon, isExternal } = props;
  const history = useHistory();

  const handleClick = (url: string): void => {
    if (isExternal) {
      window.open(url, "_blank");
    } else {
      history.push(url);
    }
  };

  if (Array.isArray(link)) {
    const items = link.map((data) => ({
      value: data.link,
      label: (
        <div className="flex gap-[0.3125rem] px-[0.9375rem] py-[0.46875rem]">
          <span>{data.projectName}</span>
          <div className="flex">
            <LaunchIcon className="!text-[1rem]" />
          </div>
        </div>
      ),
    }));
    return (
      <Dropdown
        disabled={disabled}
        icon={icon}
        items={items}
        label={label}
        onClick={handleClick}
      />
    );
  }

  const className = classNames(
    "flex",
    "items-center",
    "rounded-[0.3125rem]",
    "p-[0.46875rem]",
    "text-foreground",
    "drop-shadow",
    "bg-card",
    {
      "cursor-pointer": !disabled,
      "cursor-not-allowed": disabled,
      "opacity-60": disabled,
    },
  );

  return (
    <div
      className={className}
      onClick={(): void => {
        if (!disabled) {
          handleClick(link);
        }
      }}
    >
      <div className="flex items-center gap-[0.46875rem]">
        {icon}
        <div className="flex items-center gap-[0.3125rem]">
          <span>{label}</span>
          <sup>
            <LaunchIcon className="!text-[1rem]" />
          </sup>
        </div>
      </div>
    </div>
  );
}

export default MediaLink;
